import _objectSpread from "I:\\lcy\\\u5DE5\u4F5C\\\u7F51\u7AD9\\\u672A\u5B8C\u6210\\\u4E09\u624D\u91C7\u7F16\\\u793A\u8303\u7AD9\u70B9new\\aliyun\\samsonwebfinal\\node_modules\\@babel\\runtime-corejs2/helpers/esm/objectSpread";
import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex); //时间生成

import mutations from "./mutations";
import actions from "./actions";
import { store } from "core-js/modules/_wks";
export default new Vuex.Store({
  state: {
    name: "",
    UserInfo: "",
    top: true,
    user: true,
    footer: true,
    banner: true,
    floatAd: true,
    fixedImg: true,
    fileLoading: true,
    progressNum: 0,
    Name: "",
    index: '1',
    size: ''
  },
  getters: {
    UserInfo: function UserInfo(state) {
      return state.UserInfo;
    }
  },
  mutations: _objectSpread({
    //修改state的方法
    updateLoading: function updateLoading(state, type) {
      state.vueElementLoading = type;
    }
  }, mutations, {
    getIndex: function getIndex(state, index) {
      state.index = index;
    },
    getSize: function getSize(state, size) {
      state.size = size;
    }
  }),
  actions: actions
});